<div class="main__container">

	<breadcrumb></breadcrumb>

	<div class="section__container">
		<div class="box__container titulo__container">
			<p class="titulo">Acerca de Comunità</p>
		</div>

		<div class="contenido__box">
			<div class="nav__container">
				<nav ngbNav #nav="ngbNav" class="nav-tabs">
					<ng-container ngbNavItem>
						<a ngbNavLink>Versiones</a>
						<ng-template ngbNavContent>
							<div *ngFor="let dep of deploys; let last = last" class="version">
								<span class="badge badge-info version__numero">versión {{dep.version}}</span>

								<span class="badge badge-info version__fecha">{{getDateAsShortString( dep.date )}}</span>
								<div class="version__desc">
									<ul class="version__items">
										<li *ngFor="let feat of dep.features">{{feat}}</li>
									</ul>
								</div>
								<hr *ngIf="!last">
							</div>
						</ng-template>
					</ng-container>
					<!--
					<ng-container ngbNavItem>
						<a ngbNavLink>Compatibilidad</a>
						<ng-template ngbNavContent>
							<p>
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, voluptates et. Ipsum atque cupiditate, et a rem deserunt nihil nesciunt ducimus consequatur qui error dolores dolorem veritatis consectetur exercitationem quisquam.
							</p>
						</ng-template>
					</ng-container>
					-->
				</nav>
				<div [ngbNavOutlet]="nav"></div>
			</div>
		</div>
	</div>

</div>







